// API Configuration
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // In production on Vercel, use relative path
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  // Local development
  return 'http://localhost:3001/api';
};

export const API_BASE_URL = getApiBaseUrl();

// Helper for building API URLs
export const apiUrl = (path) => `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;

// Stripe Configuration
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

export const isStripeConfigured = !!STRIPE_PUBLISHABLE_KEY;
